import {Mixin} from "mixwith";
import {clamp} from "../../Utils/NumberUtils.js";

export const SelectionMixin = Mixin(superClass => class extends superClass {

	static get properties() {
		return {
			selected: Number,
			selectedAttribute: String,
			loop: Boolean
		};
	}

	/**
	 * @abstract Override to return the array which is holding the items.
	 * @return {*[]}
	 */
	get items() {
		return [];
	}

	set selected(value) {
		if(typeof value === "string") {
			// Find index by searching for attribute value.
			value = this.findIndexByAttribute(value);
		}

		if(!Number.isInteger(value))
			return;

		let newIndex = value;
		const oldIndex = this.__selected;
		const itemCount = this.items.length;

		if(itemCount > 0) {
			if(this.loop) {
				if(newIndex < 0)
					newIndex = itemCount - 1;
				else if(newIndex > itemCount - 1)
					newIndex = 0;
			} else
				newIndex = clamp(newIndex, 0, itemCount - 1);
		} else
			newIndex = 0;

		// No change, skip event/update
		if(newIndex === oldIndex)
			return;

		const event = this.dispatchEvent(new CustomEvent("select", {
			cancelable: true,
			detail: {
				index: newIndex,
				value: value
			}
		}));

		if(event.defaultPrevented)
			return;

		this.__selected = newIndex;

		this.requestUpdate("selected", oldIndex);
	}

	get selected() {
		return this.__selected;
	}

	constructor() {
		super();

		/**
		 * The attribute name to search for value when using strings as selected index.
		 *
		 * @type {string}
		 */
		this.selectedAttribute = "name";

		/**
		 * Will loop around edges.
		 *
		 * @type {boolean}
		 */
		this.loop = false;
	}

	/**
	 * Returns the index of the tab found by attribute or -1 if not found.
	 *
	 * @param value
	 * @param {string=} attributeName Defaults to ``this.selectedAttribute``
	 * @return {number}
	 */
	findIndexByAttribute(value, attributeName) {
		return this.items.findIndex(tab => tab.getAttribute(attributeName ?? this.selectedAttribute) === value);
	}

	selectFirst() { this.selected = 0; }
	selectPrev() { this.selected--; }
	selectNext() { this.selected++; }
	selectLast() { this.selected = this.pages.length - 1; }

});

export default SelectionMixin;